import { Box } from '../../widgets'

export const Checkbox = ({ checked, onChange, dark, error }) => (
  <Box
    border={`solid 1px ${error ? 'var(--red)' : dark ? 'black' : 'white'}`}
    radius={2}
    height={18}
    width={18}
    onClick={() => onChange(!checked)}
    cursor="pointer"
    justifyContent="center"
    alignItems="center"
  >
    {checked && <Box background="var(--blue)" height={10} width={10} />}
  </Box>
)